import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { registerFontkit } from 'pdfmake-unicode'
import Logo from '../../../assets/images/ctt-logo.png'
import { SERVICES_NAMES } from '../../../common/constants'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fontkit = registerFontkit

const generateManifestPDF = (shippings, t) => {
  const currentDate = new Date()
  const formattedDate = `${currentDate
    .getDate()
    .toString()
    .padStart(2, '0')}/${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${currentDate.getFullYear()}`

  const header = [
    { text: t('noun:shippingCode'), style: 'tableHeader' },
    { text: t('noun:clientReference'), style: 'tableHeader' },
    { text: t('noun:shippingTypeCode'), style: 'tableHeader' },
    { text: t('noun:number-of-packages'), style: 'tableHeader' },
    { text: t('noun:senderAddress2'), style: 'tableHeader' },
    { text: t('noun:recipientAddress2'), style: 'tableHeader' },
    { text: t('noun:recipientName'), style: 'tableHeader' },
    { text: t('noun:refundValue'), style: 'tableHeader' },
  ]

  const tableBody = shippings.map(shipping => [
    { text: shipping.shippingCode, style: 'tableBody' },
    { text: shipping.clientReference, style: 'tableBody' },
    {
      text: SERVICES_NAMES.hasOwnProperty(shipping.bestShippingTypeCode)
        ? SERVICES_NAMES[shipping.bestShippingTypeCode]
        : shipping.bestShippingTypeCode,
      style: 'tableBody',
    },
    { text: shipping.itemCount, style: 'tableBody' },
    { text: shipping.senderAddress2, style: 'tableBody' },
    { text: shipping.recipientAddress2, style: 'tableBody' },
    { text: shipping.recipientName, style: 'tableBody' },
    {
      text: shipping.refundValue
        ? `${parseFloat(shipping?.refundValue).toFixed(2)}€`
        : '0.00€',
      style: 'tableBody',
    },
  ])

  const styles = {
    header: {
      fontSize: 25,
      bold: true,
      margin: [0, 10, 0, 20],
      alignment: 'center',
    },
    pageNumber: {
      fontSize: 11,
      bold: true,
      margin: 20,
      alignment: 'right',
    },
    subheader: {
      fontSize: 11,
      bold: true,
      margin: [0, 0, 0, 20],
      alignment: 'right',
    },
    infoheader: {
      fontSize: 11,
      bold: true,
      margin: [20, 5, 5, 20],
      alignment: 'right',
    },
    tableHeader: {
      bold: true,
      fontSize: 10,
      color: 'black',
    },
    tableBody: {
      fontSize: 11,
    },
    logo: {
      alignment: 'center',
      margin: [0, -40, 10, -10],
    },
  }

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    info: {
      title: `${t('noun:manifest')}`,
    },
    styles,
    footer: function (currentPage, pageCount) {
      return {
        text: `${t('noun:page')}: ${currentPage.toString()}/${pageCount}`,
        style: 'pageNumber',
      }
    },
    content: [
      {
        columns: [
          {
            width: '*',
            text: `${t('noun:manifest')}`,
            style: 'header',
          },
          {
            width: 'auto',
            image: Logo,
            fit: [200, 200],
            style: 'logo',
          },
        ],
      },
      {
        columns: [
          {
            width: '*',
            text: '',
          },
          {
            width: 'auto',
            text: `${t('noun:generation-manifest-date')} ${formattedDate}`,
            style: 'subheader',
          },
        ],
      },

      {
        columns: [
          {
            width: '*',
            text: '',
          },
          {
            width: 'auto',
            text: `${t('noun:generation-manifest-packages')} ${shippings.reduce(
              (total, shipment) => total + shipment.itemCount,
              0,
            )}`,
            style: 'infoheader',
          },
          {
            width: 'auto',
            text: `${t('noun:generation-manifest-shippings')} ${
              shippings?.length
            }`,
            style: 'infoheader',
          },
          {
            width: 'auto',
            text: `${t('noun:generation-manifest-weight')} ${shippings.reduce(
              (total, shipment) => total + shipment.shippingWeight,
              0,
            )}KG`,
            style: 'infoheader',
          },
          {
            width: 'auto',
            text: `${t('noun:generation-manifest-return')} ${shippings.reduce(
              (total, shipment) =>
                total +
                (shipment?.refundValue ? parseInt(shipment?.refundValue) : 0),
              0,
            )}€`,
            style: 'infoheader',
          },
        ],
      },
      {
        table: {
          headerRows: 1,
          widths: ['21%', '12%', '12%', '7%', '13%', '13%', '13%', '9%'],
          body: [header, ...tableBody],
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex === 0 ? '#f0f0f0' : null
          },
          hLineWidth: function (i, node) {
            return 1
          },
          vLineWidth: function (i, node) {
            return 1
          },
          hLineColor: function (i, node) {
            return '#bfbfbf'
          },
          vLineColor: function (i, node) {
            return '#bfbfbf'
          },
          paddingLeft: function (i, node) {
            return 4
          },
          paddingRight: function (i, node) {
            return 4
          },
          paddingTop: function (i, node) {
            return 4
          },
          paddingBottom: function (i, node) {
            return 4
          },
        },
      },
    ],
  }

  pdfMake.createPdf(docDefinition).open({}, window.open('', '_blank'))
}

export { generateManifestPDF }
